(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3327],{

/***/ 8094:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9473);
/* harmony import */ var _helpers_functions__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6675);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5893);









const Header = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(() => Promise.all(/* import() */[__webpack_require__.e(4838), __webpack_require__.e(3219), __webpack_require__.e(7444), __webpack_require__.e(5580), __webpack_require__.e(8967)]).then(__webpack_require__.bind(__webpack_require__, 5320)), {
  ssr: false,
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(5320)]
  }
});
const Footer = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(() => Promise.all(/* import() */[__webpack_require__.e(4838), __webpack_require__.e(4396), __webpack_require__.e(7444), __webpack_require__.e(5580), __webpack_require__.e(6079), __webpack_require__.e(2945)]).then(__webpack_require__.bind(__webpack_require__, 6079)), {
  ssr: false,
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(6079)]
  }
});
const JumbotronSection = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(() => Promise.all(/* import() */[__webpack_require__.e(7473), __webpack_require__.e(1033)]).then(__webpack_require__.bind(__webpack_require__, 5748)), {
  ssr: false,
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(5748)]
  }
});
const SubscribeSection = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(() => Promise.all(/* import() */[__webpack_require__.e(3053), __webpack_require__.e(649)]).then(__webpack_require__.bind(__webpack_require__, 649)), {
  ssr: false,
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(649)]
  }
});
const ClientsSection = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(() => Promise.all(/* import() */[__webpack_require__.e(7473), __webpack_require__.e(7444), __webpack_require__.e(2873), __webpack_require__.e(1681)]).then(__webpack_require__.bind(__webpack_require__, 909)), {
  ssr: false,
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(909)]
  }
});
const WorksPageContent = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(() => Promise.all(/* import() */[__webpack_require__.e(7473), __webpack_require__.e(7444), __webpack_require__.e(2873), __webpack_require__.e(5149)]).then(__webpack_require__.bind(__webpack_require__, 3469)), {
  ssr: false,
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(3469)]
  }
});

const Home = () => {
  var _sectionData$metaTitl, _settings$appName, _sectionData$metaDesc, _sectionData$metaTitl2, _sectionData$metaDesc2, _sectionData$metaTitl3, _sectionData$metaDesc3, _sectionData$metaTitl4;

  const {
    locale,
    asPath
  } = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
  const {
    sectionData,
    settings
  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(state => state.settings);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
      title: `${sectionData === null || sectionData === void 0 ? void 0 : (_sectionData$metaTitl = sectionData.metaTitle) === null || _sectionData$metaTitl === void 0 ? void 0 : _sectionData$metaTitl[locale]} | ${settings === null || settings === void 0 ? void 0 : (_settings$appName = settings.appName) === null || _settings$appName === void 0 ? void 0 : _settings$appName[locale]}`,
      description: sectionData === null || sectionData === void 0 ? void 0 : (_sectionData$metaDesc = sectionData.metaDescription) === null || _sectionData$metaDesc === void 0 ? void 0 : _sectionData$metaDesc[locale],
      openGraph: {
        title: sectionData === null || sectionData === void 0 ? void 0 : (_sectionData$metaTitl2 = sectionData.metaTitle) === null || _sectionData$metaTitl2 === void 0 ? void 0 : _sectionData$metaTitl2[locale],
        description: sectionData === null || sectionData === void 0 ? void 0 : (_sectionData$metaDesc2 = sectionData.metaDescription) === null || _sectionData$metaDesc2 === void 0 ? void 0 : _sectionData$metaDesc2[locale]
      } // canonical={
      //   typeof window !== "undefined"
      //     ? window.location.href
      //     : `${process.env.NEXT_PUBLIC_SITE_URL}/${asPath}`
      // }
      ,
      twitter: {
        cardType: "summary_large_image",
        handle: "@handle",
        site: "@site",
        title: sectionData === null || sectionData === void 0 ? void 0 : (_sectionData$metaTitl3 = sectionData.metaTitle) === null || _sectionData$metaTitl3 === void 0 ? void 0 : _sectionData$metaTitl3[locale],
        description: sectionData === null || sectionData === void 0 ? void 0 : (_sectionData$metaDesc3 = sectionData.metaDescription) === null || _sectionData$metaDesc3 === void 0 ? void 0 : _sectionData$metaDesc3[locale],
        image: (0,_helpers_functions__WEBPACK_IMPORTED_MODULE_6__/* .handleImageLink */ .Iz)(settings === null || settings === void 0 ? void 0 : settings.appLogo)
      }
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(Header, {
      innerPages: true
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(JumbotronSection, {
      title: (sectionData === null || sectionData === void 0 ? void 0 : (_sectionData$metaTitl4 = sectionData.metaTitle) === null || _sectionData$metaTitl4 === void 0 ? void 0 : _sectionData$metaTitl4[locale]) || "",
      id: "works-page"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(WorksPageContent, {
      innerSection: true
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(SubscribeSection, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(ClientsSection, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(Footer, {})]
  });
};

var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (Home);

/***/ }),

/***/ 6675:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Iz": function() { return /* binding */ handleImageLink; },
/* harmony export */   "Yi": function() { return /* binding */ getDataBySlug; },
/* harmony export */   "xE": function() { return /* binding */ getFullDate; }
/* harmony export */ });
/* unused harmony exports getId, getTime */
// get the numeric date
const getFullDate = (date, locale) => {
  if (!date) return;
  return new Date(date).toLocaleDateString(locale === "ar" ? "ar-EG" : "en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit"
  });
}; //handle the image link if it is not a full link then add the base url

const handleImageLink = image => {
  if (image !== null && image !== void 0 && image.includes("http")) {
    return image;
  } else {
    // eslint-disable-next-line no-undef
    return `${"https://desginconcept.ejjadh.info"}/${image}`;
  }
};
const getId = obj => (obj === null || obj === void 0 ? void 0 : obj._id) || (obj === null || obj === void 0 ? void 0 : obj.id); // get time in arabic from timestamp

const getTime = (timestamp, locale) => {
  if (!timestamp) return;
  return new Date(timestamp).toLocaleTimeString(locale === "ar" ? "ar-EG" : "en-US", {
    hour: "numeric",
    minute: "numeric"
  });
}; // get data depend on slug

const getDataBySlug = (data, slug) => {
  return data === null || data === void 0 ? void 0 : data.find(item => item.slug === slug);
};

/***/ }),

/***/ 4266:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/projects",
      function () {
        return __webpack_require__(8094);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2962,9774,2888,179], function() { return __webpack_exec__(4266); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);